module.exports = __webpack_public_path__ + "static/media/dashboard.582c62f0.svg";